import { exec, getApiToken } from '@src/apis/reware/utils';
import type { ILookerDashboard } from './types';

export interface FetchLookerDashboardsArgs {
  partnerCode: string;
  token: string;
}

interface FetchLookerDashboardsExecVariables {
  token: string;
  partnerCode: string;
}

interface FetchLookerDashboardsExecResponse {
  restUser: {
    lookerDashboards: ILookerDashboard[] | null;
  };
}

/**
 * Fetches the Looker dashboards available for a partner, resolved on the
 * backend from the partner's lookerServiceConfig (service id + client
 * credentials).
 */
export const fetchLookerDashboards = async (
  { partnerCode, token }: FetchLookerDashboardsArgs
): Promise<ILookerDashboard[]> => {
  const apiToken = await getApiToken(token);

  const query = `
    query getLookerDashboards(
      $token: String!
      $partnerCode: String!
    ) {
      restUser(token: $token) {
        lookerDashboards(partnerCode: $partnerCode) {
          id
          title
          description
          folderName
        }
      }
    }
  `;

  const data = await exec<FetchLookerDashboardsExecVariables, FetchLookerDashboardsExecResponse>(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    }
  );

  return data.restUser.lookerDashboards ?? [];
};
